import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedService } from '../shared.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule, RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isHeaderOpen = false;
  isWideScreen = false;
  currentLanguage = 'de';

  constructor(private sharedService: SharedService, private translate: TranslateService) {
    this.translate.setDefaultLang('de');
    this.translate.addLangs(['en', 'de']);
    this.translate.use('de');
  }

  switchLanguage(language: string) {
    this.currentLanguage = language;
    this.sharedService.changeLanguage(language);
    this.translate.use(language);
  }

  ngOnInit() {
    this.sharedService.changeLanguage(this.currentLanguage);
    this.checkScreenWidth();
  }

  openHeaderBar() {
    this.isHeaderOpen = !this.isHeaderOpen;
    this.checkScreenWidth();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }

  checkScreenWidth() {
    if (typeof window !== 'undefined') { // Ensure this code runs only in the browser
      this.isWideScreen = window.innerWidth > 800;
      if (this.isWideScreen) {
        this.isHeaderOpen = false;
      }
    }
  }
}
